// extracted by mini-css-extract-plugin
export default {"icon":"IsRoadmapField_icon__be-Eb"};